import React, { useContext, useEffect, useState } from "react";
import { AuthContext, ThemeContext } from "../../auth";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LogoCsi,
  LogoCsiBlack,
  LogoGdk,
  LogoGsk,
  LogoPtw,
  WaterMarkCsi,
  WaterMarkGdk,
  WaterMarkGsk,
  WaterMarkPtw,
} from "../../assets/images/image";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Image,
  Row,
  Table,
} from "react-bootstrap";
import { axiosAuth } from "../../api";

function Sph() {
  const { theme } = useContext(ThemeContext);
  const location = useLocation();
  const { data, sphData } = location.state || {};
  const { accessToken } = useContext(AuthContext);
  const [salesData, setSalesData] = useState({});
  const [addressCustomerShipping, setAddressCustomerShipping] = useState();
  const [pcpData, setPcpData] = useState();
  const [pcpDetail, setPcpDetail] = useState([]);

  const languageOptions = [
    {
      value: "english",
      label: "English",
    },
    {
      value: "bahasa",
      label: "Bahasa",
    },
  ];

  const [selectedLanguage, setSelectedLanguage] = useState("bahasa");

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (selectedLanguage === value) {
      setSelectedLanguage("");
    } else {
      setSelectedLanguage(value);
    }
  };

  const dataSelectedLanguage = languageOptions.map((data, index) => {
    const isChecked = selectedLanguage === data.value;
    const isDisabled = selectedLanguage && selectedLanguage !== data.value;

    return (
      <Form.Check
        type="radio"
        inline
        key={index}
        id={`checkboxAccount-${data.value}`}
        label={data.label}
        value={data.value}
        onChange={handleCheckboxChange}
        checked={isChecked}
        // disabled={isDisabled}
        style={{ fontFamily: "Poppins-Regular" }}
      />
    );
  });

  const retrieveSales = () => {
    axiosAuth
      .get(`/api/users/${data?.createdBy}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setSalesData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && data?.createdBy !== undefined)
      retrieveSales();
  }, [accessToken, data?.createdBy]);

  const retrieveAddress = () => {
    axiosAuth
      .get(`/api/customers/addresses?customerId=${data?.customer?.id}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        const filterData = res.data.data.filter(
          (item) => item.isDefault === true,
        );

        setAddressCustomerShipping(filterData[0]);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && data?.customer?.id !== undefined)
      retrieveAddress();
  }, [accessToken, data?.customer?.id]);

  const retrievePCP = () => {
    axiosAuth
      .get(
        data?.orderType === "penjualan"
          ? `/api/pcp?leadId=${data?.id}`
          : `/api/pcp/sewa?leadId=${data?.id}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            withCredentials: true,
            Authorization: `Bearer ${accessToken}`,
          },
        },
      )
      .then((res) => {
        setPcpData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && data?.id !== undefined) retrievePCP();
  }, [accessToken, data?.id]);

  const retrievePCPDetail = () => {
    axiosAuth
      .get(
        data?.orderType === "penjualan"
          ? `/api/pcp/details?pcpId=${pcpData?.id}`
          : `/api/pcp/sewa/details?pcpId=${pcpData?.id}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            withCredentials: true,
            Authorization: `Bearer ${accessToken}`,
          },
        },
      )
      .then((res) => {
        setPcpDetail(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && pcpData?.id !== undefined)
      retrievePCPDetail();
  }, [accessToken, pcpData?.id]);

  const navigate = useNavigate();

  const numberFormat = (value) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Math.round(value / 100) * 100);

  const splitCompanyName = (companyName) => {
    const lastSpaceIndex = companyName.lastIndexOf(" ");
    if (lastSpaceIndex === -1) {
      return {
        firstValue: companyName,
        secondValue: "",
      };
    }

    const firstValue = companyName.substring(0, lastSpaceIndex);
    const secondValue = companyName.substring(lastSpaceIndex + 1);

    return {
      firstValue,
      secondValue,
    };
  };

  const companyName =
    data?.company?.companyName?.toUpperCase() || "Default Company Name";
  const { firstValue, secondValue } = splitCompanyName(companyName);

  const [showButtons, setShowButtons] = useState(true);

  const handleBack = () => {
    navigate(-1);
  };

  const handleCetak = () => {
    setShowButtons(false);
    setTimeout(() => {
      window.print();
      setShowButtons(true);
    }, 0);
  };

  const logoMap = {
    csi: LogoCsiBlack,
    ptw: LogoPtw,
    gsk: LogoGsk,
    gdk: LogoGdk,
  };

  const waterMarkMap = {
    csi: WaterMarkCsi,
    ptw: WaterMarkPtw,
    gsk: WaterMarkGsk,
    gdk: WaterMarkGdk,
  };

  const defaultLogo = LogoCsiBlack;

  const defaultWatermark = WaterMarkCsi;

  const logoSrc = logoMap[data?.company?.companyCode] || defaultLogo;

  const waterMarkSrc =
    waterMarkMap[data?.company?.companyCode] || defaultWatermark;

  const formatingDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };

    const locale = selectedLanguage === "bahasa" ? "id-ID" : "en-US";

    return date.toLocaleDateString(locale, options);
  };

  const formattedDate = formatingDate(sphData?.sphCreatedAt);

  const customerName =
    data?.customer?.title?.titleName === "Others"
      ? data?.customer?.name
      : `${data?.customer?.title?.titleName}. ${data?.customer?.name}`;

  return (
    <div
      style={{ overflowX: "hidden", overflowY: "hidden", maxWidth: "100vw" }}
    >
      {showButtons && (
        <div className="my-2 ms-2">
          <Row>
            <Col lg={2}>
              <Button
                variant="btn"
                onClick={handleCetak}
                className="me-3"
                style={{
                  backgroundColor: "#006CB8",
                  fontFamily: "Poppins-Regular",
                  color: "#FFFFFF",
                }}
              >
                Cetak
              </Button>
              <Button
                variant="btn"
                className="ms-3"
                onClick={handleBack}
                style={{
                  backgroundColor: "#464646",
                  fontFamily: "Poppins-Regular",
                  color: "#FFFFFF",
                }}
              >
                Kembali
              </Button>
            </Col>
            <Col lg={2} className="my-auto">
              <div className="d-flex align-items-center">
                {dataSelectedLanguage}
              </div>
            </Col>
          </Row>
        </div>
      )}
      <div className="mx-4 mt-3">
        <Row>
          <Col xs={4} className="text-start">
            <p style={{ fontFamily: "Poppins-SemiBold", fontSize: "24px" }}>
              Quotation
            </p>
            <p
              style={{
                fontFamily: "Poppins-Regular",
                fontSize: "12px",
                marginBottom: "0px",
              }}
            >
              No:{" "}
              <span style={{ fontFamily: "Poppins-SemiBold" }}>
                {sphData?.noSph}
              </span>
            </p>
            <p style={{ fontFamily: "Poppins-Regular", fontSize: "12px" }}>
              {selectedLanguage === "bahasa" ? (
                <>
                  Tanggal:{" "}
                  <span style={{ fontFamily: "Poppins-SemiBold" }}>
                    {formattedDate}
                  </span>
                </>
              ) : (
                <>
                  Date:{" "}
                  <span style={{ fontFamily: "Poppins-SemiBold" }}>
                    {formattedDate}
                  </span>
                </>
              )}
            </p>
          </Col>
          <Col xs={8}>
            <Row>
              <Col xs={9} className="text-end">
                <div className="mt-3">
                  <div style={{ textAlign: "right" }}>
                    <h5
                      style={{
                        fontFamily: "Poppins-SemiBold",
                        color: "#222",
                        marginBottom: "0px",
                        fontSize: "14px",
                      }}
                    >
                      PT. {firstValue} {secondValue}
                    </h5>
                    <p
                      style={{
                        fontFamily: "Poppins-Regular",
                        color: "#222",
                        fontSize: "11px",
                        marginBottom: "0px",
                        maxWidth: "250px",
                        display: "inline-block",
                        textAlign: "right",
                      }}
                    >
                      {data?.company?.address}
                    </p>
                    <p
                      style={{
                        fontFamily: "Poppins-Regular",
                        color: "#222",
                        fontSize: "11px",
                      }}
                    >
                      {data?.company?.website} | {data?.company?.phone}
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={3} className="text-end">
                <div>
                  <Image
                    src={logoSrc}
                    width={100}
                    alt={`${data?.company?.companyCode} Logo`}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <hr />
      <div className="mt-3 mx-4">
        <p
          style={{
            fontFamily: "Poppins-Medium",
            color: "#222",
            fontSize: "12px",
            marginBottom: "10px",
          }}
        >
          {selectedLanguage === "bahasa" ? <>Kepada Yth,</> : <>Dear,</>}
        </p>
        <p
          style={{
            fontFamily: "Poppins-Regular",
            color: "#222",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {selectedLanguage === "bahasa" ? <>Bpk/Ibu</> : <>Mr./Mrs.</>}{" "}
          <span
            style={{
              fontFamily: "Poppins-SemiBold",
              textTransform: "capitalize",
            }}
          >
            {data?.customer?.contactPerson}
          </span>
        </p>
        <p
          style={{
            fontFamily: "Poppins-SemiBold",
            color: "#222",
            fontSize: "14px",
            textTransform: "capitalize",
            marginBottom: "0px",
          }}
        >
          {customerName}
        </p>
        <p
          style={{
            fontFamily: "Poppins-Regular",
            color: "#222",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {addressCustomerShipping?.city}, {addressCustomerShipping?.province},{" "}
          {addressCustomerShipping?.postCode}
        </p>
        <p
          style={{
            fontFamily: "Poppins-Regular",
            color: "#222",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          Telp. {data?.customer?.phone}
        </p>
      </div>
      <div style={{ position: "fixed", left: "12%" }}>
        <Image
          src={waterMarkSrc}
          width={600}
          alt={`${data?.company?.companyCode} Watermark`}
        />
      </div>
      <div className="mt-3 mx-4">
        <Table responsive bordered>
          <thead>
            <tr>
              <th
                style={{
                  color: "#222",
                  fontFamily: "Poppins-Medium",
                  minWidth: "150px",
                  maxWidth: "150px",
                  fontSize: "13px",
                }}
              >
                Item
              </th>
              {data?.orderType === "sewa" ? (
                <th
                  style={{
                    color: "#222",
                    fontFamily: "Poppins-Medium",
                    textAlign: "center",
                    fontSize: "13px",
                  }}
                >
                  {selectedLanguage === "bahasa" ? (
                    <>Durasi Sewa (Bulan)</>
                  ) : (
                    <>Rent Duration (Month)</>
                  )}
                </th>
              ) : (
                <></>
              )}
              <th
                style={{
                  color: "#222",
                  fontFamily: "Poppins-Medium",
                  textAlign: "center",
                  maxWidth: "30px",
                  fontSize: "13px",
                }}
              >
                Qty
              </th>
              {data?.orderType === "sewa" ? (
                <th
                  style={{
                    color: "#222",
                    fontFamily: "Poppins-Medium",
                    textAlign: "right",
                    fontSize: "13px",
                  }}
                >
                  {selectedLanguage === "bahasa" ? (
                    <>Harga Sewa Perbulan</>
                  ) : (
                    <>Monthly Price</>
                  )}
                </th>
              ) : (
                <th
                  style={{
                    color: "#222",
                    fontFamily: "Poppins-Medium",
                    textAlign: "right",
                    fontSize: "13px",
                  }}
                >
                  {selectedLanguage === "bahasa" ? <>Harga</> : <>Price</>}
                </th>
              )}
              <th
                style={{
                  color: "#222",
                  fontFamily: "Poppins-Medium",
                  textAlign: "right",
                  fontSize: "13px",
                }}
              >
                Subtotal
              </th>
            </tr>
          </thead>
          <tbody>
            {pcpDetail.map((item, index) => {
              return (
                <tr key={index}>
                  <td
                    style={{
                      fontFamily: "Poppins-SemiBold",
                      textAlign: "left",
                      minWidth: "150px",
                      maxWidth: "150px",
                      fontSize: "12px",
                    }}
                  >
                    <span>{item?.productName}</span>
                    <p
                      style={{ fontFamily: "Poppins-Light", fontSize: "10px" }}
                    >
                      {item?.productDesc}
                    </p>
                  </td>
                  {data?.orderType === "sewa" ? (
                    <td
                      style={{
                        fontFamily: "Poppins-SemiBold",
                        textAlign: "center",
                        maxWidth: "30px",
                        fontSize: "12px",
                      }}
                    >
                      {item.duration / 30 || 0}
                    </td>
                  ) : (
                    <></>
                  )}
                  <td
                    style={{
                      fontFamily: "Poppins-SemiBold",
                      textAlign: "center",
                      maxWidth: "30px",
                      fontSize: "12px",
                    }}
                  >
                    {item.quantity || 0}
                  </td>
                  <td
                    style={{
                      fontFamily: "Poppins-SemiBold",
                      textAlign: "right",
                      fontSize: "12px",
                    }}
                  >
                    {numberFormat(item.sellingPrice)}
                  </td>
                  <td
                    style={{
                      fontFamily: "Poppins-SemiBold",
                      textAlign: "right",
                      fontSize: "12px",
                    }}
                  >
                    <span>{numberFormat(item.subtotal || 0)}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      <div className="mx-4 mt-3">
        <Row>
          <Col xs={8}>
            <div>
              <h4
                className=""
                style={{
                  fontFamily: "Poppins-SemiBold",
                  color: "#222",
                  fontSize: "12px",
                  marginBottom: "0px",
                }}
              >
                {selectedLanguage === "bahasa" ? (
                  <>Syarat & Ketentuan*</>
                ) : (
                  <>Terms & Conditions*</>
                )}
              </h4>
              <ul
                className=""
                style={{
                  fontFamily: "Poppins-Regular",
                  color: "#222",
                  fontSize: "12px",
                }}
              >
                <li>
                  {selectedLanguage === "bahasa" ? (
                    <>Harga franco </>
                  ) : (
                    <>Franco Price </>
                  )}{" "}
                  {pcpData?.franco
                    ? pcpData.franco.charAt(0).toUpperCase() +
                      pcpData.franco.slice(1)
                    : "Jakarta"}
                  .
                </li>
                <li>
                  {selectedLanguage === "bahasa" ? (
                    <>
                      Ketersediaan stok dan harga dapat berubah sewaktu-waktu
                      tanpa pemberitahuan terlebih dahulu.
                    </>
                  ) : (
                    <>
                      Stock availability and prices are subject to change at any
                      time without prior notice.
                    </>
                  )}
                </li>
                <li>
                  {selectedLanguage === "bahasa" ? (
                    <>Tidak diperkenankan pemesanan sebagian item.</>
                  ) : (
                    <>Partial item order are not allowed.</>
                  )}
                </li>
                <li>
                  {selectedLanguage === "bahasa" ? (
                    <>
                      Harap konfirmasi ketersediaan stok sebelum melakukan
                      pemesanan.
                    </>
                  ) : (
                    <>
                      Please confirm stock availability before placing an order.
                    </>
                  )}
                </li>
                <li>
                  {selectedLanguage === "bahasa" ? (
                    <>PO yang kami terima tidak dapat dibatalkan.</>
                  ) : (
                    <>The purchase order that we receive cannot be canceled.</>
                  )}
                </li>
                {data?.customer?.top === "Cash" ? (
                  <li>
                    {selectedLanguage === "bahasa" ? (
                      <>Jangka waktu pembayaran: Cash.</>
                    ) : (
                      <>Term of payment: Cash.</>
                    )}
                  </li>
                ) : (
                  <li>
                    {selectedLanguage === "bahasa" ? (
                      <>Jangka waktu pembayaran: CBD (Cash Before Delivery).</>
                    ) : (
                      <>Term of payment: CBD (Cash Before Delivery).</>
                    )}
                  </li>
                )}
              </ul>
              {pcpData?.description ? (
                <div>
                  <h4
                    className=""
                    style={{
                      fontFamily: "Poppins-SemiBold",
                      color: "#222",
                      fontSize: "12px",
                      marginBottom: "0px",
                    }}
                  >
                    {selectedLanguage === "bahasa" ? (
                      <>Syarat & Ketentuan Tambahan*</>
                    ) : (
                      <>Additional Terms & Conditions*</>
                    )}
                  </h4>
                  <ul
                    className=""
                    style={{
                      fontFamily: "Poppins-Regular",
                      color: "#222",
                      fontSize: "12px",
                    }}
                  >
                    {pcpData.description.split("\n").map((line, index) => (
                      <li key={index}>{line}</li>
                    ))}
                  </ul>
                </div>
              ) : (
                <></>
              )}
            </div>
          </Col>
          <Col xs={4} className="text-end">
            <div
              style={{
                color: "#222",
              }}
            >
              <p
                className="text-end p-1"
                style={{
                  fontFamily: "Poppins-SemiBold",
                  fontSize: "12px",
                  marginBottom: "0px",
                }}
              >
                Total: {numberFormat(pcpData?.salesTotal)}
              </p>
              <p
                className="text-end p-1"
                style={{
                  fontFamily: "Poppins-SemiBold",
                  fontSize: "12px",
                  marginBottom: "0px",
                }}
              >
                PPN {pcpData?.ppnPercentage}%: {numberFormat(pcpData?.ppn)}
              </p>
              <p
                className="text-end p-1"
                style={{
                  fontFamily: "Poppins-SemiBold",
                  fontSize: "12px",
                  marginBottom: "0px",
                }}
              >
                Grand Total: {numberFormat(pcpData?.grandTotal)}
              </p>
            </div>
            <div style={{ marginTop: "80px" }}>
              <p
                style={{
                  fontFamily: "Poppins-Regular",
                  color: "#222",
                  fontSize: "12px",
                  marginTop: "0px",
                }}
              >
                {selectedLanguage === "bahasa" ? (
                  <>Hormat kami,</>
                ) : (
                  <>Regards,</>
                )}
              </p>
              <p
                style={{
                  fontFamily: "Poppins-SemiBold",
                  color: "#222",
                  fontSize: "12px",
                  marginBottom: "0px",
                  textTransform: "capitalize",
                }}
              >
                {salesData?.firstName} {salesData?.lastName}
              </p>
              <p
                style={{
                  fontFamily: "Poppins-SemiBold",
                  color: "#222",
                  fontSize: "12px",
                }}
              >
                Sales Executive
              </p>
            </div>
          </Col>
        </Row>
      </div>
      <footer
        className="mx-4 text-end"
        style={{ fontFamily: "Poppins-Light", fontSize: "10px" }}
      >
        {selectedLanguage === "bahasa" ? (
          <>
            *Dokumen ini dibuat secara otomatis oleh aplikasi, tanda tangan
            tidak diperlukan.
          </>
        ) : (
          <>
            *This document is automatically generated by the application, no
            signature is required.
          </>
        )}
      </footer>
    </div>
  );
}

export default Sph;
